module.exports = __webpack_public_path__ + "img/icon-play.d42b923.png";